import LatestEventWidget from '../../widgets/LatestEventWidget';
import { loadWidgetData, RELOAD_INTERVAL } from './common';

const SUB_TYPES = [ 'subscription', 'subGiftReceive', 'subExtend', 'subStreak' ];

const VARIANTS = {
	'latest-follower': {
		options: { eventFilter: msg => msg.type === 'follow' },
		loadLatest: async host => {
			const alerts = await host.api.get(`widget/${encodeURIComponent(host.hash)}/alerts`, { limit: 50 }).catch(() => []);
			return (alerts || []).find(a => a.message?.type === 'follow');
		},
	},
	'latest-subscriber': {
		options: { eventFilter: msg => SUB_TYPES.includes(msg.type) },
		loadLatest: async host => {
			const alerts = await host.api.get(`widget/${encodeURIComponent(host.hash)}/alerts`, { limit: 50 }).catch(() => []);
			return (alerts || []).find(a => SUB_TYPES.includes(a.message?.type));
		},
	},
	'latest-donation': {
		options: { eventFilter: msg => (msg.convertedValue || 0) > 0 },
		loadLatest: host => host.api.get(`widget/${encodeURIComponent(host.hash)}/alerts/latestDonation`).catch(() => null),
	},
	'top-donation': {
		options: { eventFilter: msg => (msg.convertedValue || 0) > 0, isTopMode: true },
		loadLatest: host => host.api.get(`widget/${encodeURIComponent(host.hash)}/alerts/topDonation`, { hours: 6 }).catch(() => null),
	},
};

export default function createLatestEventMounter(type) {
	const variant = VARIANTS[type];
	return async function mountLatestEvent(host) {
		const load = () => loadWidgetData(host, [ 'userData', 'serviceIcons' ]);
		const data = await load();

		const widget = new LatestEventWidget({ container: host.container, ...variant.options });
		await widget.init(data);
		widget.applyServiceIcons(data.serviceIcons);

		const latest = await variant.loadLatest(host);
		if(latest) widget.onAlert(latest);

		host.onSettingsChange(s => widget.applySettings(s));

		async function reload() {
			const d = await load();
			widget.applyUserData(d.userData);
			widget.applySettings(d.settings);
			widget.applyServiceIcons(d.serviceIcons);
		}

		host.subscribe({
			reconnect: reload,
			userWidgetAlert: msg => widget.onAlert(msg),
		});

		host.every(reload, RELOAD_INTERVAL);
		host.onDestroy(() => widget.destroy());
	};
}
